import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function CallbackModal() {
    const [params] = useSearchParams();

    useEffect(() => {
        const status = params.get("status");
        const reqId = params.get("reqId");
        const type = params.get("type");

        console.log("CAS Result:", { status, reqId, type });

        if (status === "success") {
            alert("CAS Completed Successfully ✅");

            // 👉 yahan tum API call kar sakte ho
            // backend ko reqId bhejne ke liye

        } else {
            alert("CAS Failed ❌");
        }
    }, []);

    return <h2>Processing CAS Response...</h2>;
}